/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        subtitle: 'dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'apps',
        title: 'Applicants',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
            {
                id: 'apps.applicants',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/applicants'
            },
            {
                id: 'apps.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:lightning-bolt',
                link: '/applicants/recent'
            },
            {
                id: 'apps.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/applicants/favourite'
            },
            {
                id: 'apps.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/applicants/archive'
            }
        ]
    },
    {
        id: 'cust',
        title: 'Customers',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
            {
                id: 'cust.customers',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/customers'
            },
            {
                id: 'cust.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:lightning-bolt',
                link: '/customers/recent'
            },
            {
                id: 'cust.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/customers/favourite'
            },
            {
                id: 'cust.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/customers/archive'
            },
            {
                id: 'cust.contacts',
                title: 'Contacts',
                type: 'basic',
                icon: 'heroicons_outline:phone',
                link: '/customers/contacts'
            }
        ]
    },
    {
        id: 'projs',
        title: 'Projects',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
            {
                id: 'projs.all',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/projects'
            },
            {
                id: 'projs.active',
                title: 'Active',
                type: 'basic',
                icon: 'heroicons_outline:view-list',
                link: '/projects/active'
            },
            {
                id: 'projs.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:lightning-bolt ',
                link: '/projects/recent'
            },
            {
                id: 'projs.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/projects/favourite'
            },
            {
                id: 'projs.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/projects/archive'
            }
        ]
    },
    // {
    //     id      : 'offers',
    //     title   : 'Offers',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:clipboard-check',
    //     children: [
    //         {
    //             id   : 'offers.all',
    //             title: 'All',
    //             type : 'basic',
    //             icon : 'heroicons_outline:collection',
    //             link : '/offers'
    //         },
    //         {
    //             id   : 'offers.archive',
    //             title: 'Archive',
    //             type : 'basic',
    //             icon : 'heroicons_outline:archive',
    //             link : '/offers/archive'
    //         }
    //     ]
    // },
    {
        id: 'workingPartners',
        title: 'Working Partners',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'workingPartners.freelancers',
                title: 'Freelancers',
                type: 'basic',
                icon: 'heroicons_solid:user-group',
                link: 'wp/freelancers'
            },
            {
                id: 'workingPartners.employees',
                title: 'Employees',
                type: 'basic',
                icon: 'mat_solid:supervised_user_circle',
                link: 'wp/employees'
            },
            {
                id: 'workingPartners.employeebench',
                title: 'Employees Bench',
                type: 'basic',
                icon: 'mat_outline:work',
                link: 'wp/employee-bench'
            },
            {
                id: 'workingPartners.freelancerbench',
                title: 'Freelancer Bench',
                type: 'basic',
                icon: 'mat_outline:workspaces',
                link: 'wp/freelancer-bench'
            },
            // {
            //     id   : 'workingPartners.vacations',
            //     title: 'Vacation Requests',
            //     type : 'basic',
            //     icon : 'heroicons_outline:star',
            //     link : 'wp/vacations'
            // },
        ]
    },
    {
        id: 'timesheet',
        title: 'Timesheets',
        type: 'group',
        icon: 'heroicons_outline:newspaper',
        children: [
            {
                id: 'timesheet.list',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/timesheets'
            },
            {
                id: 'timesheet.uninvoiced',
                title: 'Un-invoiced',
                type: 'basic',
                icon: 'heroicons_outline:currency-euro',
                link: '/timesheets/un-invoiced'
            },
            {
                id: 'timesheet.Reporting',
                title: 'Timesheets Reporting',
                type: 'basic',
                icon: 'heroicons_outline:chart-square-bar',
                link: '/timesheets/timesheet-reporting'
            },
            // {
            //     id   : 'timesheet.vacations',
            //     title: 'Wage Reporting',
            //     type : 'basic',
            //     icon : 'heroicons_outline:currency-euro',
            //     link : '/timesheets/wage-reporting'
            // },
        ]
    },
    {
        id: 'Other',
        title: '',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'tasks',
                title: 'Tasks',
                type: 'basic',
                icon: 'heroicons_outline:check-circle',
                link: '/tasks'
            },
            {
                id: 'settings',
                title: 'Settings',
                subtitle: 'Settings',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: '/settings'
            },]
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'apps',
        title: 'Applicants',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'apps.applicants',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/applicants'
            },
            {
                id: 'apps.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:chat-alt',
                link: '/applicants/recent'
            },
            {
                id: 'apps.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/applicants/favourite'
            },
            {
                id: 'apps.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:cloud',
                link: '/applicants/archive'
            }
        ]
    },
    {
        id: 'cust',
        title: 'Customers',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
            {
                id: 'cust.customers',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/customers'
            },
            {
                id: 'cust.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:chat-alt',
                link: '/customers/recent'
            },
            {
                id: 'cust.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/customers/favourite'
            },
            {
                id: 'cust.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:cloud',
                link: '/customers/archive'
            },
            {
                id: 'cust.contacts',
                title: 'Contacts',
                type: 'basic',
                icon: 'heroicons_outline:phone',
                link: '/customers/contacts'
            }
        ]
    },
    {
        id: 'proj',
        title: 'Projects',
        type: 'group',
        icon: 'heroicons_outline:briefcase',
        children: [
            {
                id: 'proj.all',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/projects'
            },
            {
                id: 'projs.active',
                title: 'Active',
                type: 'basic',
                icon: 'heroicons_outline:view-list',
                link: '/projects/active'
            },
            {
                id: 'proj.recent',
                title: 'Recent',
                type: 'basic',
                icon: 'heroicons_outline:lightning-bolt',
                link: '/projects/recent'
            },
            {
                id: 'proj.favorite',
                title: 'Favorite',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/projects/favourite'
            },
            {
                id: 'proj.archive',
                title: 'Archive',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/projects/archive'
            }
        ]
    },
    // {
    //     id      : 'offers',
    //     title   : 'Offers',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:clipboard-check',
    //     children: [
    //         {
    //             id   : 'offers.all',
    //             title: 'Freelancers',
    //             type : 'basic',
    //             icon : 'heroicons_outline:collection',
    //             link : '/offers'
    //         },
    //         {
    //             id   : 'offers.archive',
    //             title: 'Archive',
    //             type : 'basic',
    //             icon : 'heroicons_outline:archive',
    //             link : '/offers/archive'
    //         }
    //     ]
    // },
    {
        id: 'workingPartners',
        title: 'Working Partners',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'workingPartners.freelancers',
                title: 'Freelancers',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: 'wp/freelancers'
            },
            {
                id: 'workingPartners.employees',
                title: 'Employees',
                type: 'basic',
                icon: 'heroicons_outline:lightning-bolt',
                link: 'wp/employees'
            },
            {
                id: 'workingPartners.employeebench',
                title: 'Employees Bench',
                type: 'basic',
                icon: 'heroicons_outline:employee',
                link: 'wp/employeebench'
            },
        ]
    },
    {
        id: 'timesheet',
        title: 'Timesheets',
        type: 'group',
        icon: 'heroicons_outline:newspaper',
        children: [
            {
                id: 'timesheet.list',
                title: 'All',
                type: 'basic',
                icon: 'heroicons_outline:collection',
                link: '/timesheets'
            },
            {
                id: 'timesheet.uninvoiced',
                title: 'Un-invoiced',
                type: 'basic',
                icon: 'heroicons_outline:currency-euro',
                link: '/timesheets/un-invoiced'
            },
            {
                id: 'timesheet.Reporting',
                title: 'Timesheets Reporting',
                type: 'basic',
                icon: 'heroicons_outline:chart-square-bar',
                link: '/timesheets/timesheet-reporting'
            },
            {
                id   : 'timesheet.vacations',
                title: 'Wage Reporting',
                type : 'basic',
                icon : 'heroicons_outline:currency-euro',
                link : '/timesheets/wage-reporting'
            },
        ]
    },
    // {
    //     id: 'activity-log',
    //     title: 'Activity Log',
    //     type: 'basic',
    //     icon: 'heroicons_outline:clipboard-list',
    //     link: '/activity-log'
    // },
    {
        id: 'settings',
        title: 'Settings',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: '/settings'
    },
];


//NOTES:
//LINK ROUTE
